var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.fastDeliverySetId)?_c('div',{staticClass:"absolute top-0 left-8 z-20 h-10 w-10 cursor-pointer items-center justify-center flex"},[_c('img',{staticClass:"inline-block ml-2 h-8",attrs:{"src":require("assets/img/icon/icon_fast_delivery.svg"),"alt":"Fast Delivery"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }